module.exports = __webpack_public_path__ + "static/media/dataanalysis.cc62ceab.webp";